import { render, staticRenderFns } from "./Tool.vue?vue&type=template&id=8a87c640&"
import script from "./Tool.vue?vue&type=script&lang=js&"
export * from "./Tool.vue?vue&type=script&lang=js&"
import style0 from "./Tool.vue?vue&type=style&index=0&id=8a87c640&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports